<template>
    <div>
        <LabelContent title="基本信息" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="150px" class="unitWidth" size="small">
                <el-form-item label="设备编号">
                    <el-input v-model.trim="devCode" @blur="getPlanMantainItem" placeholder="请输入设备编号(必填)" :disabled="devCodeShow"></el-input>
                </el-form-item>
                <el-form-item label="计划工时">
                    <el-input v-model.trim="pmoRatedHour" placeholder="请输入计划工时(必填)" :disabled="devCodeShow"></el-input>
                </el-form-item>
                <el-form-item label="计划执行月份">
                    <el-date-picker v-model="pmoPlanTime" type="month" placeholder="选择日期时间(必填)" :disabled="devCodeShow"></el-date-picker>
                </el-form-item>
                <el-form-item label="执行开始时间">
                    <el-date-picker v-model="pmoPlanStartTime" type="datetime" placeholder="选择执行开始时间(必填)" :disabled="pmoPlanTimeShow"></el-date-picker>
                </el-form-item>
                <el-form-item label="执行结束时间">
                    <el-date-picker v-model="pmoPlanEndTime" type="datetime" placeholder="选择执行结束时间(必填)" :disabled="pmoPlanTimeShow"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addPlanMantainOrder">确定</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="planMantainList" class="center" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="pmiPart" sortable label="保养部位" show-overflow-tooltip/>
                <el-table-column prop="pmiItem" sortable label="保养项目描述" show-overflow-tooltip />
                <el-table-column prop="pmiRespType" sortable label="保养方法" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.pmiRespType == 'visual'">目视</span>
                        <span v-if="scope.row.pmiRespType == 'action'">动作</span>
                        <span v-if="scope.row.pmiRespType == 'replace'">更换</span>
                        <span v-if="scope.row.pmiRespType == 'clean'">清扫</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mainType" sortable label="保养类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.mainType == 'mechanics'">机械</span>
                        <span v-if="scope.row.mainType == 'electrical'">电气</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" sortable label="创建时间" show-overflow-tooltip />
            </el-table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: 'addPlanMantainOrder',
        data(){
            return{
                searchParams: {},
                devCode:'',
                pmoPlanTime:'',
                pmoPlanStartTime:'',
                pmoPlanEndTime:'',
                pmoRatedHour:'',
                planMantainList:[],
                access:[],
                devCodeShow:false,
                pmoPlanTimeShow:false,
                str:'',
                planMainList:[]
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            /*for (let i = 0; i < this.access.length; i++) {
                if(this.access[i] == 'D0001'){
                    this.devCodeShow = false
                    break
                }else{
                    this.devCodeShow = true
                }
            }
            for (let j = 0; j < this.access.length; j++) {
                if(this.access[j] == 'D0002'){
                    this.pmoPlanTimeShow = false
                    break
                }else{
                    this.pmoPlanTimeShow = true
                }
            }*/
        },
        methods:{
            handleSelectionChange(val){
                this.planMainList = val
                var str = ''
                for (let i = 0; i < val.length; i++) {
                    console.log(val[i].pmiId)
                    str += val[i].pmiId + ','
                }
                var arr = str.substring(0,str.length - 1)
                this.str = arr
            },
            addPlanMantainOrder(){
                var self = this
                if(self.devCode == undefined || self.devCode == ''){
                    self.$message.info("请输入设备编号")
                    return
                }
                if(self.pmoPlanTime == undefined || self.pmoPlanTime == ''){
                    self.$message.info("请输入计划执行时间")
                    return
                }
                if(self.pmoPlanStartTime == undefined || self.pmoPlanStartTime == ''){
                    self.$message.info("请输入执行开始时间")
                    return
                }
                if(self.pmoPlanEndTime == undefined || self.pmoPlanEndTime == ''){
                    self.$message.info("请输入执行结束时间")
                    return
                }
                if(self.pmoRatedHour == undefined || self.pmoRatedHour == ''){
                    self.$message.info("请输入计划工时")
                    return
                }
                if(self.planMainList.length == 0){
                    self.$message.info("至少选择一个保养项")
                    return
                }
                let queryParams = {
                    devCode:self.devCode,
                    pmoPlanTime:moment(self.pmoPlanTime).format("YYYY-MM"),
                    pmoRatedHour:self.pmoRatedHour,
                    pmiIds:self.str
                }
                if(self.pmoPlanStartTime != undefined && self.pmoPlanStartTime != ''){
                    queryParams['pmoPlanStartTime'] = self.dateFormat(self.pmoPlanStartTime)
                }
                if(self.pmoPlanEndTime != undefined && self.pmoPlanEndTime != ''){
                    queryParams['pmoPlanEndTime'] = self.dateFormat(self.pmoPlanEndTime)
                }
                let options = {
                    method:'POST',
                    url:this.$api.addPlanMaintainOrder,
                    data:queryParams
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        self.$message.success("新增成功")
                        self.getPlanMantainItem()
                        this.$router.push({path:'/planMantainOrder'})
                    }else{
                        self.$message.error(response.message)
                    }
                })
            },
            getPlanMantainItem(){
                if(this.devCode == undefined || this.devCode == ''){
                    return
                }
                let queryParams = {
                    devCode:this.devCode
                }
                let options = {
                    method:'GET',
                    url:this.$api.getPlanMantainItemDevCode,
                    params:queryParams
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        this.planMantainList = response.data
                    }
                })
            },
            dateFormat(date){
                return moment(date).format("YYYY-MM-DD HH:mm:ss")
            }
        }
    }
</script>

<style scoped>

</style>
